import { createStyles, makeStyles } from "@material-ui/core";
import Lottie from "lottie-react-web";
import React from "react";

interface Props {}

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  })
);

const Loader: React.FC<Props> = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Lottie
        options={{
          animationData: require("../../assets/loading.json"),
          loop: true,
          autoplay: true,
        }}
        height={"300px"}
        width={"300px"}
      />
    </div>
  );
};

export default React.memo(Loader);
